/* Leeft lander — section behaviours.
   Idempotent: safe to load once and run against sections added by the theme editor. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (root.dataset.lfInit) return;
    root.dataset.lfInit = '1';
    var main = $('[data-lf-gal-main]', root);
    var thumbs = $('[data-lf-gal-thumbs]', root);
    if (!main || !thumbs) return;
    var imgs = $$('img', main);

    function hydrate(img) {
      if (!img || !img.dataset.lfSrc) return;
      img.srcset = img.dataset.lfSrcset || '';
      img.src = img.dataset.lfSrc;
      delete img.dataset.lfSrc;
      delete img.dataset.lfSrcset;
    }

    $$('button', thumbs).forEach(function (b, i) {
      /* fetch on intent so the swap feels instant */
      ['mouseenter', 'touchstart', 'focus'].forEach(function (evt) {
        b.addEventListener(evt, function () { hydrate(imgs[i]); }, { passive: true, once: true });
      });
      b.addEventListener('click', function () {
        hydrate(imgs[i]);
        imgs.forEach(function (x) { x.classList.remove('is-on'); });
        if (imgs[i]) imgs[i].classList.add('is-on');
        $$('button', thumbs).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    /* warm the second slide once the page is idle, never before */
    var warm = function () { hydrate(imgs[1]); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
    else setTimeout(warm, 3000);
  }

  /* ---------- Accordions ---------- */
  function initAcc(acc) {
    if (acc.dataset.lfInit) return;
    acc.dataset.lfInit = '1';
    $$('.acc-item', acc).forEach(function (item) {
      var btn = $('.acc-btn', item), panel = $('.acc-panel', item);
      if (!btn || !panel) return;
      function setOpen(open) {
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      }
      if (item.classList.contains('is-open')) requestAnimationFrame(function () { setOpen(true); });
      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        $$('.acc-item', acc).forEach(function (o) {
          if (o === item) return;
          o.classList.remove('is-open');
          var b = $('.acc-btn', o), p = $('.acc-panel', o);
          if (b) b.setAttribute('aria-expanded', 'false');
          if (p) p.style.maxHeight = '0px';
        });
        setOpen(open);
      });
    });
  }

  /* ---------- Review filters ---------- */
  function initReviews(root) {
    if (root.dataset.lfInit) return;
    root.dataset.lfInit = '1';
    var chips = $('[data-lf-chips]', root);
    var cards = $$('[data-lf-review]', root);
    if (!chips) return;
    chips.addEventListener('click', function (e) {
      var chip = e.target.closest('.chip');
      if (!chip) return;
      var f = chip.getAttribute('data-f');
      $$('.chip', chips).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      var shown = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(',');
        var show = f === 'all' || tags.indexOf(f) > -1;
        card.hidden = !show;
        if (show) shown++;
      });
      var empty = $('[data-lf-review-empty]', root);
      if (empty) empty.hidden = shown > 0;
    });
  }

  /* ---------- Energy curve ----------
     Lines render fully drawn by default; we only hide-then-draw when the
     animation can actually run, so reduced-motion users still see the chart. */
  function initCurve(curve) {
    if (curve.dataset.lfInit) return;
    curve.dataset.lfInit = '1';
    if (reduce || !('IntersectionObserver' in window)) return;
    var lines = $$('.ln', curve);
    if (!lines.length) return;
    lines.forEach(function (p) {
      var len = Math.ceil(p.getTotalLength());
      p.style.strokeDasharray = len;
      p.style.strokeDashoffset = len;
      p.style.transition = 'stroke-dashoffset 1.9s cubic-bezier(.4,0,.2,1)';
    });
    /* Once a line has finished drawing, strip the dash properties entirely.
       Leaving stroke-dasharray on can clip the tail of the path in some
       renderers even at offset 0, so the resting state is a plain stroke. */
    function settle(p) {
      p.style.transition = '';
      p.style.transitionDelay = '';
      p.style.strokeDasharray = '';
      p.style.strokeDashoffset = '';
    }
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      lines.forEach(function (p, i) {
        var delay = i * 0.35;
        p.style.transitionDelay = delay + 's';
        p.style.strokeDashoffset = 0;
        p.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'stroke-dashoffset') return;
          p.removeEventListener('transitionend', handler);
          settle(p);
        });
        /* belt and braces if transitionend never fires */
        setTimeout(function () { settle(p); }, (delay + 1.9) * 1000 + 400);
      });
      io.disconnect();
    }, { threshold: 0.3 });
    io.observe(curve);
  }

  /* ---------- Sticky add-to-cart ---------- */
  function initSticky(bar) {
    if (bar.dataset.lfInit) return;
    bar.dataset.lfInit = '1';
    var buy = $('[data-lf-buybox]');
    var closer = $('[data-lf-closer]');
    if (!buy || !('IntersectionObserver' in window)) return;
    var buyVis = true, closerVis = false;
    function sync() { bar.classList.toggle('is-on', !buyVis && !closerVis); }
    new IntersectionObserver(function (es) { buyVis = es[0].isIntersecting; sync(); },
      { threshold: 0.04 }).observe(buy);
    if (closer) {
      new IntersectionObserver(function (es) { closerVis = es[0].isIntersecting; sync(); },
        { threshold: 0.35 }).observe(closer);
    }
    var btn = $('[data-lf-sticky-add]', bar);
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = $('[data-lf-product-form]');
        if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
        else { buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      });
    }
  }

  /* ---------- Purchase option selector ---------- */
  function initPlans(root) {
    if (root.dataset.lfInit) return;
    root.dataset.lfInit = '1';
    var plans = $$('.plan, .pcard', root);
    if (plans.length < 2) return;
    var planInput = $('[data-lf-selling-plan]');
    var idInput = $('[data-lf-product-form] [name="id"]');
    var cta = $('[data-lf-cta-price]');
    plans.forEach(function (plan) {
      plan.addEventListener('click', function () {
        plans.forEach(function (p) { p.classList.remove('is-on'); });
        plan.classList.add('is-on');
        var radio = $('input[type=radio]', plan);
        if (radio) radio.checked = true;

        /* selling-plan mode */
        if (planInput && plan.hasAttribute('data-selling-plan')) {
          planInput.value = plan.getAttribute('data-selling-plan') || '';
        }
        /* variant mode: point the form at the chosen variant */
        var vid = plan.getAttribute('data-variant-id');
        if (vid && idInput) idInput.value = vid;

        var price = plan.getAttribute('data-price');
        if (cta && price) cta.textContent = price;
        var sb = $('[data-lf-sticky-price]');
        if (sb && price) sb.textContent = price;

        /* cards style: note under the options follows the selection */
        var note = $('[data-lf-plan-note]');
        var noteText = plan.getAttribute('data-note');
        if (note && noteText) note.textContent = noteText;
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var rvs = $$('.rv', scope).filter(function (el) { return !el.dataset.lfInit; });
    rvs.forEach(function (el) { el.dataset.lfInit = '1'; });
    if (!rvs.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      rvs.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    rvs.forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(el);
    });
    /* Safety net: never leave copy invisible if the observer misfires. */
    setTimeout(function () {
      rvs.forEach(function (el) {
        if (el.getBoundingClientRect().top < innerHeight * 1.5) el.classList.add('in');
      });
    }, 1500);
  }

  function boot(scope) {
    scope = scope || document;
    $$('[data-lf-gallery]', scope).forEach(initGallery);
    $$('[data-acc]', scope).forEach(initAcc);
    $$('[data-lf-reviews]', scope).forEach(initReviews);
    $$('[data-lf-curve]', scope).forEach(initCurve);
    $$('[data-lf-sticky]', scope).forEach(initSticky);
    $$('[data-lf-plans]', scope).forEach(initPlans);
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }

  window.addEventListener('resize', function () {
    $$('.acc-item.is-open .acc-panel').forEach(function (p) { p.style.maxHeight = p.scrollHeight + 'px'; });
  });

  /* Theme editor: re-init sections as they are added or reloaded */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
